import { ExternalLink, Icons } from '@agro-club/agroclub-shared'
import { refetchFunc } from 'modules/domain/common/hooks'
import { SellerSpec } from 'modules/domain/deal/types'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import { BorderedItem } from 'views/components/BorderedItem/BorderedItem'
import formatPrice from '../../../../../../modules/utils/numbers/formatPrice'
import { ButtonsWrapper } from '../styled'
import { EditSellerSpecification } from './SellerSpecificationModal/EditSellerSpecification'
import useFormatDate from 'hooks/useFormatDate'
import { DASH } from 'modules/constants'

type Props = {
  specifications: SellerSpec[]
  refetch: refetchFunc
}

export const SpecificationList: FC<Props> = ({ specifications, refetch }) => {
  const { t } = useTranslation('deal')
  const [editModal, setEditModal] = useState(false)
  const formatDate = useFormatDate()
  const spec = specifications[0]
  if (!spec) return null

  return (
    <div>
      <BorderedItem>
        <div>
          <div>{t('common:price:price', { price: formatPrice(spec.price, true) })}</div>
          <div>
            {t('loadingDates')}, {t('common:from')}{' '}
            {spec.loading_start_date ? formatDate(spec.loading_start_date) : DASH} {t('common:until')}{' '}
            {spec.loading_end_date ? formatDate(spec.loading_end_date) : DASH}
          </div>
        </div>
        <ButtonsWrapper>
          <AButton
            id="editSpecification"
            color="secondary"
            background="none"
            Icon={Icons.IconEdit}
            onClick={() => setEditModal(true)}
          />
        </ButtonsWrapper>
      </BorderedItem>
      {editModal && (
        <EditSellerSpecification onClose={setEditModal} onSuccess={refetch} specification={specifications} />
      )}
      {spec.files?.map((file) => (
        <BorderedItem key={file.id}>
          <ExternalLink href={file.uploaded_file} target="_blank">
            {file.original_filename}
          </ExternalLink>
        </BorderedItem>
      ))}
    </div>
  )
}
